

import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite, Timeline, Ease, Elastic} from "gsap";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinGameConfig} from "../HarlequinGameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {HarlequinReelSymbol} from "../symbols/HarlequinReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {NudgeReelEvent} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeReelEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../HarlequinSoundConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class HarlequinWildNudge implements GameRoundPresentation {

    private readonly _reelId:number;
    private readonly _stepDuration:number;
    private readonly _abortDuration:number;
    private _tl:TimelineLite;

    private _gameData:HarlequinParsedGameData;
    private _hasWin:boolean;
    private _wasNudgeThisRound:boolean;
    private _noWinNudge:boolean = false;

    protected _nudgeSymbolId:number[] = [];
    protected _nudgeState:boolean[] = [];
    protected _steps:number[] = [];
    protected _currentSymbol:HarlequinReelSymbol | null;
    protected _symbolsToNudge: HarlequinReelSymbol [] = [];

    protected hasStarted:boolean = false;
    protected currentStep:number = 0;
    protected _mpValue:number = 1;
    protected  _mpSteps:number [] = [];
    private _wildMultipliers:number [] = [];

    private _aborted:boolean = false;
    private _abortDone:boolean = false;

    private _nudgedSteps:number = 1;
    private _delay:number = 0;



    constructor(reelId:number, stepDuration:number = 0.2, abortDuration:number) {
        this._reelId = reelId;
        this._stepDuration = 0.6;
        this._abortDuration = abortDuration;
        this.hasStarted = false;
        this.currentStep = 0;
        this._aborted = false;
        this._abortDone = false;
    }

    protected onNudgeStepStart(reelId:number, totalSteps:number):void {
        if(this._reelId === reelId) {
            let symbol:HarlequinReelSymbol = <HarlequinReelSymbol>Reels.getSymbol(reelId, this._nudgeSymbolId[reelId]);

            if(symbol && ["W*0", "W*1", "W*2"].indexOf(symbol.symName) < 0) {
                symbol = <HarlequinReelSymbol>Reels.getSymbol(reelId, this._nudgeSymbolId[reelId] + 1);
            }
            if(symbol) {
                this._currentSymbol = symbol;
            }

            if(this._nudgedSteps > -1 && this._nudgedSteps < 2) {
                if(this._nudgedSteps === 0) {
                    //console.log("Playing nudge 2, ns: " + this._nudgedSteps);
                    if(!this._aborted) {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_NUDGE_2);
                    }
                } else {
                    //console.log("Playing nudge 1, ns: " + this._nudgedSteps);
                    if(!this._aborted) {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_NUDGE_1);
                    }
                }
                this._nudgedSteps--;
            }
            //console.log("NUDGE STEPPED! value: " + this._mpValue);
        }

    }
    protected onNudgeStepCompleted(reelId:number, nudgeSteps:number):void {
        if(this._reelId === reelId) {
            //console.log("Nudge step complete, rid: " + this._reelId + ", nudge steps: " + nudgeSteps);
            //const symbol:HarlequinReelSymbol = <HarlequinReelSymbol>Reels.getSymbol(reelId, this._nudgeSymbolId[reelId]);
            //this._mpValue = this._mpValue + 1;

            if(this._currentSymbol) {

                    (<HarlequinReelSymbol> this._currentSymbol).changeState({
                        state: HarlequinGameConfig.instance.SYMBOL_STATES.nudge,
                        // setStack : true,
                        fadeInDuration: 0.5
                    }, undefined, this._steps[2]);
                    this.hasStarted = true;


                    const val: number = this._mpSteps[this.currentStep] + (this.currentStep + 1);
                    if (!isNaN(val)) {
                        this._mpValue = val;
                    }
                    this._currentSymbol.playNudgeSpine(this._mpSteps[this.currentStep] + (this.currentStep + 1));
                    this._currentSymbol.updateMpValue(this._mpValue);
                    if(!this._aborted) {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_MULTIPLIER);
                    }


                if(this.currentStep < this._mpSteps.length -1) {
                    this.currentStep = this.currentStep + 1;
                }
                else {
                    this.currentStep = 0;
                }

            }
        }

    }
    protected onNudgeCompleted(reelId:number):void {
        if(this._reelId === reelId) {

            // TODO: Remove spine instance et al?

            EventHandler.removeEventListener(this, NudgeReelEvent.NUDGE_STEP_START);
            EventHandler.removeEventListener(this, NudgeReelEvent.NUDGE_STEP_COMPLETED);
            EventHandler.removeEventListener(this, NudgeReelEvent.NUDGE_COMPLETED);

            if(this._currentSymbol) {
                //this._currentSymbol.updateMpValue(this._mpValue);
                this._currentSymbol = null;
            }

            if(this._aborted) {
                if(this._reelId === 3) {
                    //debugger;
                }
                if(!this._abortDone) {
                    this._abortDone = true;
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_NUDGE_ABORT);
                }
                HarlequinGameModuleConfig.harlequinWalkerView.restoreAndShowOverlay(this._reelId, undefined, this._wildMultipliers, true, this._wildMultipliers[this._reelId], true);
            }
        }

    }

    public prepare(data:HarlequinParsedGameData):void {
        this._aborted = false;
        this._abortDone = false;
        this.currentStep = 0;
        this._symbolsToNudge.length = 0;
        this._steps = [];
        this._mpValue = 1;
        this._mpSteps.length = 0;
        this._gameData = data;
        this._hasWin = (data.doReelNudge)? data!.doReelNudge[this._reelId] : false;
        this._wasNudgeThisRound = !(data.doReelNudge.every((value) => {
            return !value;
        }));
        this._wildMultipliers = data.wildMultipliers || [];

        if(this._hasWin) {
            EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_START, (event: GameEvent) => this.onNudgeStepStart(event.params[0], event.params[1]));
            EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_COMPLETED, (event: GameEvent) => this.onNudgeStepCompleted(event.params[0], event.params[1]));
            EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_COMPLETED, (event: GameEvent) => this.onNudgeCompleted(event.params[0]));
        }
        this._nudgedSteps = 1;
    }

    public getAnimation(data:HarlequinParsedGameData):Timeline | null{
        const tl = new TimelineLite();

        if (!this._hasWin){
            return null;
        }

        /*tl.add(() => {
            this._mpValue = 1;
        });*/

        if(this._hasWin) {
            this._delay = (Math.abs(this._steps[1]) * 1.15) + 1.2;
            //debugger;
            tl.add((!this._aborted)? () => this.doReelNudge(this._reelId, (this._aborted)? 0 : 0.2) : () => {});
            tl.add((!this._aborted)? () => this.playNudge(0) : () => {}, 0.5);
            tl.add(() => {
                // TODO: ugly delay temp
                if(this._aborted) {
                    this.onNudgeCompleted(this._reelId);
                }
            }, (!this._aborted)? "+=" + this._delay : "+=0.2");
        }

       // if(this._reelId === 3 && this._wasNudgeThisRound) {
            tl.add(() => {
                // TODO: ugly delay temp
                //this._mpValue = 1;
            }, (!this._aborted)? 2.25 : 0.4);
       // }


        this._tl = tl;
        return tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        this._aborted = true;
        if(isActive && this._tl) {
            this._aborted = true;
            this._tl.timeScale(10);
            return this._tl;
        }
        else {
            if(this._hasWin) {
                //console.log("Aborted new TL!");
                this._aborted = true;
                this._delay = 0.2;
                this._tl.timeScale(10);
                GameRoundManager.detachAndPlayTimeline(this._tl);
                const tl: TimelineLite = new TimelineLite();
                tl.add(() => {}, 0.2);
                return tl;
            }
        }
        return null;
    }

    protected isNoWinNudge(data:HarlequinParsedGameData):boolean {
        //const hasWin:boolean = this._betWinsData != null && this._betWinsData.length > 0;
        //return !hasWin;

        return false;
    }

    // The range is the startIndex (include) in the reel symbols to the endIndex (NOT include).
    // If there are 3 symbols in reel, the index is [0, 3].
    // If you have a special feature that the are actually 5 symbols but you only show 3 symbols from the bottom of the 5 symbols, then you should return [2, 5].
    protected getNudgeRange(reelId:number):[number, number] {
        return [0, HarlequinGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]]; // TODO: does this do anything?
    }


    private doReelNudge(reelId:number, delay:number):void {
        this._nudgeState[reelId] = true;
        const reelSymbols:string[] = this._gameData!.reels[reelId];
        const symbolsToNudge: HarlequinReelSymbol [] = [];
        let symbolIndex:number = -1;
        let stackIndex:number = -1;
        const checkRange:[number, number] = this.getNudgeRange(reelId);
        for(let i:number = checkRange[0]; i < checkRange[1]; i++) {
            const symbol: StateReelSymbol = Reels.getSymbol(reelId, i, false)!;
            if (symbol && symbol.symName.indexOf("W") > -1) { // this._nudgeConfig.stackedSymbolKeyword
                symbolIndex = i;
                stackIndex = symbol.stackedSymName!.index;
                symbolsToNudge.push(<HarlequinReelSymbol> symbol);
                //console.log("SYMBOLS TO NUDGE");
                //console.log(symbolsToNudge);
                break;
            }
        }

        if(symbolIndex === -1) {
            debugger;
            throw new Error(`NudgeStackedSymbolWPController.doReelNudge():There is no symbol contains ${this._gameData} in a nudging reel. reelId = ${reelId}, symbols = ${reelSymbols.toString()}`);
        }

        // TODO: SUPER IMPORTANT, when calculating which symbol to grab for nudge, we don't want to include the filler symbols (i.e the they need to be retracted form num_sym_dumb ccalculation)
        // TODO: we do in plus indexes.
        this._nudgeSymbolId[reelId] = (symbolIndex < 1)? symbolIndex - (HarlequinGameConfig.instance.SYMBOLS_NUM_IN_REEL[1] - 2) : symbolIndex - (HarlequinGameConfig.instance.SYMBOLS_NUM_IN_REEL[1]);
        this._steps[reelId] = stackIndex - symbolIndex + checkRange[0];
        this._symbolsToNudge = symbolsToNudge;
        this.currentStep = 0;

        for(let i = 0; i < Math.abs(this._steps[this._reelId]); i++) {
            this._mpSteps.push(1);
        }
    }

    playNudge(delay:number):void {
        const ease:Ease = Elastic.easeIn.config(1, 1);
        //debugger;
        if(!this._aborted) {
            (<NudgeSpinReelController>Reels.getReel(this._reelId)).nudge(this._steps[this._reelId], (this._noWinNudge || this._aborted) ? 0.001 : this._stepDuration, ease, delay);
        }
        else {
            this.onNudgeCompleted(this._reelId);
        }
    }
}